import { render } from "./AllCustomers.vue?vue&type=template&id=2e50780e"
import script from "./AllCustomers.vue?vue&type=script&lang=js"
export * from "./AllCustomers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__